<div style="margin-bottom: 20px; width: 100%; display: block;">
    <div style="margin-top: 10px; margin-bottom: 5px; display: flex; gap: 12px;">
        <button (click)="exportData(exportOptionsTemplate)" class="btn btn-success" style="height: 30px; margin-right: 10px; padding-top: 1px;">Export</button>

        <label style="margin-right: 10px; margin-top: 2px;">Readings Per page: </label>
        <input type="radio" [(ngModel)]="readingsPerTablePage" name="readingsPerTablePage" value=15 style="margin-top: 1px;" (ngModelChange)="changeReadingsPerTablePage(15)" />
        <label style="margin-right: 10px; margin-top: 2px;">15</label>
        <input type="radio" [(ngModel)]="readingsPerTablePage" name="readingsPerTablePage" value=50 style="margin-top: 1px;" (ngModelChange)="changeReadingsPerTablePage(50)" />
        <label style="margin-right: 10px; margin-top: 2px;">50</label>
        <input type="radio" [(ngModel)]="readingsPerTablePage" name="readingsPerTablePage" value=100 style="margin-top: 1px;" (ngModelChange)="changeReadingsPerTablePage(100)" />
        <label style="margin-right: 10px; margin-top: 2px;">100</label>
        <input type="radio" [(ngModel)]="readingsPerTablePage" name="readingsPerTablePage" value=500 style="margin-top: 1px;" (ngModelChange)="changeReadingsPerTablePage(500)" />
        <label style="margin-right: 10px; margin-top: 2px;">500</label>
        <input type="radio" [(ngModel)]="readingsPerTablePage" name="readingsPerTablePage" value=1000 style="margin-top: 1px;" (ngModelChange)="changeReadingsPerTablePage(1000)" />
        <label style="margin-right: 10px; margin-top: 2px;">1000</label>
    </div>

        <!-- [scrollable]="true" scrollHeight="553px" -->

    <p-table #sensorReadingsTable [columns]="sensorReadingsCols" [value]="sensorReadingInfosForPage"  pageLinks="15" 
                            [lazy]="true" (onLazyLoad)="updateReadingsTable($event)" [paginator]="true" rows={{readingsPerTablePage}} totalRecords="{{sensorReadingInfosCount}}" [loading]="busyProcessing">
        
        <ng-template let-columns pTemplate="header">
            <tr style="height: 40px; margin-top: 1px;">
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.field == 'gps'" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                    <p-sortIcon *ngIf="col.field != 'gps'" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template let-columns="columns" let-rowData ; pTemplate="body">
            <tr style="height: 35px;">
                <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                    {{rowData.sensorName}}
                </td>

                <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                    {{rowData.createdDate | date : 'medium'}}
                </td>

                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                    {{rowData.tag}}
                </td>

                <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                    {{rowData.type}}
                </td>

                <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                    <div *ngIf="includeOrigValues"> {{ rowData.origValue }} </div>
                </td>
                
                <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                    <div *ngIf="includeCalValues"> {{ rowData.value }} </div>
                </td>

                <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px; text-align: center;">
                    <i class="fa-solid fa-location-dot"
                       [style.color]="common.readingGpsPinColor(rowData)"
                       [title]="common.readingGpsPinTooltip(rowData)"></i>
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>


<ng-template #exportOptionsTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Export Options</h5>
        <button
          (click)="exportOptionsModalRef.hide()"
          type="button"
          class="ms-auto fas fa-times"
          style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
      </div>
      <div class=" modal-body" [ngStyle]="{'background-color':'white'}">
        <div style="margin-bottom: 20px; display: flex; gap: 20px;">
          <div class="form-group" style="width: 500px;">
              <label for="exportFilename">Filename</label>
              <input type="text" id="exportFilename" name="exportFilename" class="form-control" [(ngModel)]="exportDataCriteria.filename" style="height: 35px;" required>
          </div>
        </div>
        <div style="margin-bottom: 10px; display: flex; gap: 12px;">
          <label style="margin-right: 10px;" for="saveAs">Save As:</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="CSV2" style="margin-top: 5px;" />
          <label style="margin-right: 10px;">CSV</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="JSON" style="margin-top: 5px;" />
          <label style="margin-right: 10px;">JSON</label>
        </div>

        <hr>
        <label style="margin-bottom: 15px;">Options </label>

        <div style="margin-bottom: 15px; display: flex; gap: 12px;">
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateData" name="interpolateData" [value]=false style="margin-top: 5px;" />
          <label>Use original time stamped data (no interpolation)</label>
        </div>

        <div style="margin-bottom: 10px; display: flex; gap: 12px;">
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateData" name="interpolateData" [value]=true style="margin-top: 5px;" />
          <label>Interpolate data before exporting</label>
        </div>

        <div style="margin-bottom: 10px; margin-left: 26px; display: flex; gap: 12px;">
          <label for="interval">Interval:</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="15 Min" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">15 Min</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="30 Min" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">30 Min</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="1 Hr" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">1 Hr</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="24 Hrs" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">24 Hrs</label>
        </div>

        <div style="margin-bottom: 20px; margin-left: 26px; display: flex; gap: 12px;">
          <label for="interval">Method:</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateMethod" name="interpolateMethod" value="Linear" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">Linear</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateMethod" name="interpolateMethod" value="Spline" style="margin-top: 5px;" disabled=true (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">Spline</label>
        </div>

        <div style="margin-bottom: 10px; display: flex; gap: 12px;">
          <input type="checkbox" [(ngModel)]="exportDataCriteria.ignoreOutliers" [ngModelOptions]="{standalone: true}" [checked]="exportDataCriteria.ignoreOutliers" style="margin-top: 5px; vertical-align: middle;" />
          <label>Ignore outlier data</label>
        </div>

        <div style="margin-bottom: 10px; margin-left: 26px; display: flex; gap: 12px;">
          <label>Less than</label>
          <input type="text" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.ignoreOutliersLessThan" [ngModelOptions]="{standalone: true}"/>
        </div>

        <div style="margin-bottom: 10px; margin-left: 26px; display: flex; gap: 12px;">
          <label>or greater than</label>
          <input type="text" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.ignoreOutliersGreaterThan" [ngModelOptions]="{standalone: true}"/>
        </div>

        <div style="margin-bottom: 20px; display: flex; gap: 12px;">
          <input type="checkbox" [(ngModel)]="exportDataCriteria.includeGpsInfo" [ngModelOptions]="{standalone: true}"
                  [checked]="exportDataCriteria.includeGpsInfo" [disabled]="exportDataCriteria.saveAs != 'JSON' || exportDataCriteria.interpolateData" style="margin-top: 5px; vertical-align: middle;" />
          <label>Include GPS Info</label>
        </div>

        <hr>
        <div>
          <button type="button" class="btn btn-info" (click)="exportDataWithOptions()" style="float: right; margin-right: 1px; margin-bottom: 15px; margin-top: 3px;">Export</button>
        </div>

      </div>
  </div>
</ng-template>
